/* 
Site global JS, as a rule of thumb, 
this should only contain JS that is 
needed for the majority of pages on the site.
*/
import './resource_v1';

(function($){
	
	$(document).ready(function(){
        // here we go
		$('.fl-tabs-labels').removeClass('fl-clearfix');
	});
	
})(jQuery);

import './nav';